var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.167,
    height: 23.246,
    viewBox: "0 0 25.167 23.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-cart",
    "data-name": "Icon ionic-ios-cart",
    transform: "translate(-3.382 -4.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M12.467,29.577a1.452,1.452,0,1,1-1.452-1.452,1.452,1.452,0,0,1,1.452,1.452Z",
    transform: "translate(-0.861 -3.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M28.253,29.577A1.452,1.452,0,1,1,26.8,28.125a1.452,1.452,0,0,1,1.452,1.452Z",
    transform: "translate(-3.059 -3.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M28.54,8.626a.356.356,0,0,0-.315-.254L8.514,6.466a.607.607,0,0,1-.454-.284,6.163,6.163,0,0,0-.738-1.126c-.466-.569-1.344-.551-2.953-.563a.882.882,0,0,0-.986.853.865.865,0,0,0,.944.853A8.041,8.041,0,0,1,5.9,6.315c.284.085.514.551.6.956a.022.022,0,0,0,.006.018c.012.073.121.617.121.623L9.047,20.718a4.706,4.706,0,0,0,.878,2.161,2.415,2.415,0,0,0,1.991.98H26.234a.86.86,0,0,0,.871-.811.843.843,0,0,0-.847-.884H11.9A.7.7,0,0,1,11.4,22a2.716,2.716,0,0,1-.7-1.574l-.26-1.434a.033.033,0,0,1,.024-.036l16.806-2.844a.354.354,0,0,0,.3-.315l.968-7.008A.345.345,0,0,0,28.54,8.626Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.784bfa24c5d8c93d9d4b91b7203a9724.svg";
export { ForwardRef as ReactComponent };